"use client"

import type React from "react"
import { SocialSectionComponent } from "./components/social-section.component"
import { SubFooterComponent } from "./components/sub-footer.component"
import { data } from "../data"
import { navs } from "../header/components/nav-items"

type IFooterContainerComponentProps = {}

export const FooterContainerComponent: React.FC<IFooterContainerComponentProps> = (
    props: IFooterContainerComponentProps,
) => {
    const { services } = data

    const contactDetails = [
        {
            title: "Address",
            description:
                "The Goldfield Mall, Office No-305, 3rd Floor, Behind TATA Motors, Near International Exhibition Center, Sec No-11 PCNTDA CNG Pump Road, Chikhali, Pune -411062",
            icon: "geo-alt",
        },
        {
            title: "Call Us",
            description: "+91 8956757974",
            icon: "telephone",
        },
        {
            title: "Email Us",
            description: "sales@italentoutsourcing.com",
            icon: "envelope",
        },
    ]

    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url: string) => {
        if (url.includes("#")) {
            e.preventDefault()
            const sectionId = url.split("#")[1]
            const sectionElement = document.getElementById(sectionId)

            if (sectionElement) {
                window.scrollTo({
                    top: sectionElement.offsetTop - 100,
                    behavior: "smooth",
                })
            }
        } else if (url === "/home") {
            e.preventDefault()
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            })
        }
    }

    return (
        <footer id="footer" className="footer dark-background" data-aos="fade-up" data-aos-delay="400">
            <div className="container">
                <div className="row" style={{ textAlign: "left" }}>
                    <div className="col-12 col-lg-4 mb-5">
                        <a
                            href="/home"
                            onClick={(e) => handleNavClick(e, "/home")}
                            className="logo d-flex align-items-center me-auto me-xl-0"
                        >
                            <img loading="lazy" src="/assets/img/iLogo.png" style={{ height: "60px" }} alt="italent-logo" />
                        </a>
                        <p className="mt-4">
                            As seasoned consultants and practitioners, we specialize in navigating the intricate landscape of Labour
                            Law and allied services, offering comprehensive solutions tailored to the unique needs of businesses
                            operating in Pan India.{" "}
                        </p>
                        <p>
                            We understand the critical importance of maintaining compliance with the ever-evolving statutory
                            requirements, and we are committed to providing meticulous and reliable support.
                        </p>
                    </div>
                    <div className="col-12 col-lg-8">
                        <div className="row">
                                <div className="col-12 col-md-4 mb-5">
                                    <h4 className="text-white mb-4 footer-heading">Quick Links</h4>
                                    <div className="d-flex flex-column">
                                        {navs.map((link, index) => {
                                            return (
                                                <a
                                                    key={index}
                                                    href={link.url}
                                                    onClick={(e) => handleNavClick(e, link.url)}
                                                    className="text-white mb-3 footer-nav-link"
                                                >
                                                    {link.name}
                                                </a>
                                            )
                                        })}
                                    </div>
                                </div>

                                <div className="col-12 col-md-4 mb-5">
                                    <h4 className="text-white mb-4 footer-heading">Timing</h4>
                                    <p className="text-white-50">Mon - Sat: 9:00AM - 6:00PM</p>
                                </div>

                                <div className="col-12 col-md-4 mb-5">
                                    <h4 className="text-white mb-4 footer-heading">Contact Us</h4>
                                    <div className="d-flex flex-column">
                                        {contactDetails.map((detail, index) => (
                                            <div key={index} className="footer-contact-item d-flex mb-4">
                                                <div className="contact-icon-wrapper">
                                                    <i className={`bi bi-${detail.icon}`}></i>
                                                </div>
                                                <div className="ms-3">
                                                    <h6 className="text-white mb-1">{detail.title}</h6>
                                                    <p className="text-white-50 small mb-0">
                                                        {detail.icon === "telephone" ? (
                                                            <a href={`tel:${detail.description}`} className="text-white-50 text-decoration-none">
                                                                {detail.description}
                                                            </a>
                                                        ) : detail.icon === "envelope" ? (
                                                            <a href={`mailto:${detail.description}`} className="text-white-50 text-decoration-none">
                                                                {detail.description}
                                                            </a>
                                                        ) : (
                                                            detail.description
                                                        )}
                                                    </p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                        </div>
                </div>
                </div>

                <SocialSectionComponent />
                <SubFooterComponent />
            </div>
        </footer>
    )
}
